import { render, staticRenderFns } from "./registerMerchant.vue?vue&type=template&id=ff8e5eee&scoped=true&"
import script from "./registerMerchant.vue?vue&type=script&lang=js&"
export * from "./registerMerchant.vue?vue&type=script&lang=js&"
import style0 from "./registerMerchant.vue?vue&type=style&index=0&lang=css&"
import style1 from "./registerMerchant.vue?vue&type=style&index=1&id=ff8e5eee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8e5eee",
  null
  
)

export default component.exports